import { useSortable } from "@dnd-kit/sortable";
import { __ } from '@wordpress/i18n';
import { CSS } from "@dnd-kit/utilities";
import MoveButton from './icon/move-button.svg';
import CloneButton from './icon/clone-button.svg';
import ElementorButton from './icon/elementor-button.svg';
import SettingButton from './icon/setting-button.svg';
import TrashButton from './icon/trash-button.svg';
import ArrowButton from './icon/arrow-button.svg';
import CheckButton from './icon/check-button.svg';
import { useState } from "react";
import { getPost } from "./helper";



export default function TemplateItem(props) {

    const { openEditForm, priority, activeTab, duplicateTemplate, updateStatus, item, deleteItem } = props;
    const { id, title, url } = item;

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({ id: id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };

    const handleEditForm = (id) => {
        getPost(id).then(result => {
            openEditForm(priority - 1, {
                ...item,
                condition: result
            })
        });
    }

    const openElementorEditor = (url) => {
        window.open(url, '_blank'); // buka di tab baru
        // atau gunakan '_self' jika ingin buka di tab yang sama
    };

    if (activeTab === 'draft') {
        return (
            <ul className="sortable-items">
                <li className="tab-detail" >
                    <div className="item">
                        <span>{title}</span>
                    </div>
                </li>
                <li className="jkit-select">
                    <div className="item">
                        <StatusSelect key={id} activeTab={activeTab} updateStatus={updateStatus} id={id} />
                    </div>

                </li>
                <li className="jkit-icon-button fill edit-elementor" onClick={() => openElementorEditor(url)} >
                    <div className="item">

                        <ElementorButton />
                        <span className="tooltip-text">{__('Edit on Elementor', 'jeg-elementor-kit')}</span>
                    </div>
                </li>

                <li className="jkit-icon-button stroke" onClick={() => deleteItem(id)} >
                    <div className="item">
                        <TrashButton />
                        <span className="tooltip-text">{__('Delete', 'jeg-elementor-kit')}</span>
                    </div>

                </li>
            </ul>
        );
    }

    return (
        <ul className="sortable-items" ref={setNodeRef} style={style} {...attributes}>
            <li className="tab-detail grab" {...listeners} style={{
                cursor: 'grab',
            }} >
                <div className="item">
                    <MoveButton />
                    <span>{title}</span>
                </div>
            </li>

            <li className="jkit-number">
                <div className="item">
                    {priority}
                </div>
            </li>

            <li className="jkit-select">
                <div className="item">
                    <StatusSelect key={id} activeTab={activeTab} updateStatus={updateStatus} id={id} />
                </div>
            </li>
            <li className="jkit-icon-button stroke" onClick={() => handleEditForm(id)}>
                <div className="item">
                    <SettingButton />
                    <span className="tooltip-text">{__('Template Setting', 'jeg-elementor-kit')}</span>
                </div>
            </li>
            <li className="jkit-icon-button fill edit-elementor" onClick={() => openElementorEditor(url)} >
                <div className="item">
                    <ElementorButton />
                    <span className="tooltip-text">{__('Edit on Elementor', 'jeg-elementor-kit')}</span>
                </div>
            </li>
            <li className="jkit-icon-button stroke" onClick={() => duplicateTemplate(item)}>
                <div className="item">
                    <CloneButton />
                    <span className="tooltip-text">{__('Clone', 'jeg-elementor-kit')}</span>
                </div>
            </li>
            <li className="jkit-icon-button stroke" onClick={() => deleteItem(id)} >
                <div className="item">
                    <TrashButton />
                    <span className="tooltip-text">{__('Delete', 'jeg-elementor-kit')}</span>
                </div>
            </li>
        </ul>
    );
}

const StatusSelect = ({ activeTab, updateStatus, id }) => {

    const [open, setOpen] = useState(false);
    const status = activeTab === 'publish' ? 'active' : 'inactive';
    return <div className='status-select-wrapper'>
        <div onClick={() => setOpen(!open)} className={`active-status handle ${status}`}>
            <span className="label">
                <span className="dots"></span>
                <span>{status}</span>
            </span>
            <ArrowButton />
        </div>
        {open && <div className='status-dropdown'>
            <div className="active-status options active" onClick={() => updateStatus(id, 'draft', 'publish')}>
                <span className="label">
                    <span className="dots"></span>
                    <span>active</span>
                </span>
                {status === 'active' && <CheckButton />}
            </div>

            <div className="active-status options inactive" onClick={() => updateStatus(id, 'publish', 'draft')}>
                <span className="label">
                    <span className="dots"></span>
                    <span>inactive</span>
                </span>
                {status === 'inactive' && <CheckButton />}
            </div>
        </div>}
    </div>;
}



